import list from './list';
import getById from './getById';
import followUpGet from './followUpGet';
import followUpCreate from './followUpCreate';
import followUpUpdate from './followUpUpdate';
import followUpDelete from './followUpDelete';
import questions from './questions';
import create from './create';
import update from './update';
import remove from './remove';

export default [list, getById, followUpGet, followUpCreate, followUpUpdate, followUpDelete, questions, create, update, remove];
